'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseLoader = require('@bibliocommons/base-loader');

var _baseLoader2 = _interopRequireDefault(_baseLoader);

var _carouselBase = require('@bibliocommons/carousel-base');

var _carouselBase2 = _interopRequireDefault(_carouselBase);

var _recommendationItem = require('@bibliocommons/recommendation-item');

var _recommendationItem2 = _interopRequireDefault(_recommendationItem);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseIcons = require('@bibliocommons/base-icons');

require('../styles/Recommendations.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Recommendations = function (_BcReactComponent) {
  _inherits(Recommendations, _BcReactComponent);

  function Recommendations(props) {
    _classCallCheck(this, Recommendations);

    var _this = _possibleConstructorReturn(this, (Recommendations.__proto__ || Object.getPrototypeOf(Recommendations)).call(this, props));

    _this.state = {
      isExpanded: false
    };

    _this.bindAll('handleClick', 'renderSlider');
    return _this;
  }

  _createClass(Recommendations, [{
    key: 'componentDidMount',
    value: function componentDidMount() {/** Need that in test to make sure that component got rendered properly **/}
  }, {
    key: 'handleClick',
    value: function handleClick() {
      if (!this.props.loaded) {
        this.props.getRecommendations(this.props.itemId);
      }

      this.setState({ isExpanded: !this.state.isExpanded });
    }
  }, {
    key: 'renderSlider',
    value: function renderSlider() {
      var _props = this.props,
          zeroResults = _props.zeroResults,
          loaded = _props.loaded,
          recommendations = _props.recommendations,
          handleClickRecommendation = _props.handleClickRecommendation;

      if (loaded && zeroResults) {
        return _react2.default.createElement(
          _reactIntl.FormattedMessage,
          { id: 'while_you_wait_empty' },
          function (message) {
            return _react2.default.createElement(
              'p',
              { className: 'empty-result' },
              message
            );
          }
        );
      }

      if (loaded && !zeroResults) {
        return _react2.default.createElement(
          _carouselBase2.default.BaseCarousel,
          {
            buttonBackgroundColor: '#f9f9f9',
            breakpointSettings: {
              10000: {
                useTouchArrows: false,
                itemsPerPage: 5,
                partiallyShowOffscreenItems: false,
                showDots: true,
                gutterSize: '25px'
              },
              787: {
                useTouchArrows: false,
                itemsPerPage: 4,
                partiallyShowOffscreenItems: false,
                showDots: true,
                gutterSize: '25px'
              },
              610: {
                useTouchArrows: false,
                itemsPerPage: 3,
                partiallyShowOffscreenItems: false,
                showDots: true,
                gutterSize: '25px'
              },
              525: {
                useTouchArrows: false,
                itemsPerPage: 2,
                partiallyShowOffscreenItems: false,
                showDots: true,
                gutterSize: '25px'
              }
            },
            titleData: {} },
          (0, _map3.default)(recommendations, function (item) {
            return _react2.default.createElement(_recommendationItem2.default, { key: item.id, item: item, handleClick: handleClickRecommendation });
          })
        );
      }

      return _react2.default.createElement(
        _reactIntl.FormattedMessage,
        { id: 'while_you_wait_loading' },
        function (message) {
          return _react2.default.createElement(_baseLoader2.default, { message: message });
        }
      );
    }
  }, {
    key: 'renderSourceMessage',
    value: function renderSourceMessage() {
      if (this.state.isExpanded) {
        return _react2.default.createElement(
          _reactIntl.FormattedMessage,
          { id: 'recommendations_powered_by', values: { service: this.props.type } },
          function (message) {
            return _react2.default.createElement(
              'small',
              { className: 'recommendation-source' },
              message
            );
          }
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var isExpanded = this.state.isExpanded;

      var recommendationsClass = (0, _classnames2.default)('cp-recommendations', { 'is-expanded': isExpanded });
      return _react2.default.createElement(
        'div',
        { className: recommendationsClass },
        _react2.default.createElement(
          _baseButtons.TextButton,
          { className: 'while-you-wait-toggle', 'data-test-id': 'whileyouwait-toggle', handleClick: this.handleClick },
          _react2.default.createElement(
            _baseIcons.IconWithBackground,
            {
              bgColor: '#cc441e',
              icon: _react2.default.createElement(_baseIcons.Clock, null) },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'while_you_wait_title' }),
            _react2.default.createElement(_baseIcons.Carets.Down, { className: (0, _classnames2.default)('resource-expand-icon', { rot90: !this.state.isExpanded }) })
          ),
          this.props.loaded && this.renderSourceMessage()
        ),
        this.state.isExpanded && this.renderSlider()
      );
    }
  }]);

  return Recommendations;
}(_baseBcReactComponent2.default);

Recommendations.propTypes = {
  getRecommendations: _react.PropTypes.func.isRequired,
  handleClickRecommendation: _react.PropTypes.func.isRequired,
  itemId: _react.PropTypes.string.isRequired,
  recommendations: _react.PropTypes.arrayOf(_react.PropTypes.object),
  type: _react.PropTypes.string,
  loaded: _react.PropTypes.bool
};

exports.default = Recommendations;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/recommendations/lib/components/Recommendations.component.js
// module id = 1460
// module chunks = 1